export default {
      id: "clock_sun_storm-usage",
      viewBox: "0 0 200 160",
      url: __webpack_public_path__ + "live-atlas/img/icons.e641665a.svg#clock_sun_storm",
      toString: function () {
        return this.url;
      }
    }